import { GQL_ALTER_LIKE } from "@/graphql/like.graphql";
import { useMutation } from "@apollo/react-hooks";
import { useRouter } from "next/router";
import { useLazyGetLikeStatus, useMetaLikeAndComment } from "./useMeta";

export const useLike = (fatherId: string) => {
  const router = useRouter();
  const [_alterLike, { loading: loadingAlter }] = useMutation<
    { alterLike: boolean },
    { ald: { fatherId: string; like: boolean; url: string } }
  >(GQL_ALTER_LIKE);
  const { getLike, loading: loadingGet } = useLazyGetLikeStatus(fatherId);
  const { likedStatus, likedTimeCount } = useMetaLikeAndComment(fatherId);
  const alterLike = async (like: boolean, url?: string) => {
    await _alterLike({
      variables: { ald: { fatherId, like, url: url ?? router.asPath } },
    });
    getLike();
  };
  const handleLike = async (url?: string) => {
    if (likedStatus) {
      await alterLike(false, url);
    } else {
      await alterLike(true, url);
    }
  };
  return {
    alterLike,
    handleLike,
    getLike,
    loading: loadingAlter || loadingGet,
    likedStatus,
    likedTimeCount,
  };
};
